import React from 'react';
import PropTypes from 'prop-types';
import "./Form.scss";
import Socials from "../../components/Socials/Socials";
import Fields from "../../components/Form/Fields/Fields";
import Checkboxes from "../../components/Form/Checkboxes/Checkboxes";
import API from "../../Helpers/API";
import Button from "../../components/UI/Button/Button";
import axios from "axios";
import Parser from "html-react-parser";

class Form extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: [
        {
          id: "form-name",
          name: "name",
          placeholder: "Как вас зовут?",
          value: "",
          errorMessage: "ввести Ваше имя"
        },
        {
          id: "form-email",
          name: "email",
          placeholder: "Ваш е-mail",
          value: "",
          errorMessage: "ввести адрес электронной почты"
        },
        {
          id: "form-phone",
          name: "phone",
          placeholder: "Ваш телефон",
          value: "",
          errorMessage: "ввести телефон"
        },
      ],
      checkboxes: [
        {
          id: "policy-private",
          name: "policy-private",
          label: `Я даю свое согласие на&nbsp;обработку, хранение, передачу, в&nbsp;том числе трансграничную передачу, моих персональных данных с&nbsp;целью участия в&nbsp;настоящей акции и&nbsp;соглашаюсь с <a href="https://www.lg.com/ru/privacy" target="_blank" rel="noopener noreferrer">Политикой конфиденциальности</a> и <a href="https://www.lg.com/ru/personaldata" target="_blank" rel="noopener noreferrer">Политикой в отношении обработки персональных данных</a>.`,
          isActive: true,
          hasError: false,
          errorMessage: "дать свое согласие на обработку, хранение и передачу персональных данных"
        },
        {
          id: "policy-marketing",
          name: "policy-marketing",
          label: "Я согласен получать рекламные и&nbsp;маркетинговые рассылки от&nbsp;ООО «ЛГ Электроникс РУС» и&nbsp;ООО «Лаборатория Инноваций»",
          isActive: true,
          hasError: false,
          errorMessage: "согласиться получать рекламные и маркетинговые рассылки от ООО «ЛГ Электроникс РУС» и ООО «Лаборатория Инноваций»"
        },
      ],

    };

  }

  componentDidMount() {
    const code = window.location.search.split("code=")[1] || null;
    const driver = localStorage.getItem("authSocial");

    if (code && driver) {

      API("/api/v1/auth/social/info", { driver, code }, data => {
        const { fields } = this.state;

        fields.forEach(field => field.value = data[field.name]);

        window.history.pushState("", "", window.location.pathname);

        this.setState({ fields });

      }, () => window.history.pushState("", "", window.location.pathname));

    }

  }

  validate(input) {
    let { value, name } = input;
    switch (name) {
      case 'name':
        return value.length < 3;
      case 'email':
        return !/^[a-zA-Z0-9\.\-_]{1,}\@([a-zA-Z0-9\-_]{1,}\.){1,2}[a-zA-Z]{2,4}$/.test(value);
      case 'phone':
        return value.length !== 11;
      default:
        return value < 0;
    }
  }

  onChangeInput = event => {
    let { fields } = this.state;
    const target = event.currentTarget;

    fields.forEach(field => {
      if (field.name === target.getAttribute("name")) {
        if (field.name === "phone") {
          field.value = target.value.length < 12 ? target.value.replace(/([^0-9]+)/gi, '') : field.value;
        } else {
          field.value = target.value;
        }
        field.hasError = false;
      }
    });

    this.setState({ fields });

  }

  onChangeCheckbox = input => {
    let { checkboxes } = this.state;

    checkboxes.forEach(checkbox => {

      if (checkbox.name === input.name) {
        checkbox.isActive = !checkbox.isActive;
        checkbox.hasError = false;
      }

    });

    this.setState({ checkboxes });
  }

  collectData() {
    const { fields, checkboxes } = this.state;
    const data = {};
    let hasError = false;

    fields.forEach(field => {

      if (this.validate(field)) {
        field.hasError = true;
        hasError = true;
      }

      data[field.name] = field.value;

    });

    checkboxes.forEach(checkbox => {

      if (!checkbox.isActive) {
        checkbox.hasError = true;
        hasError = true;
      }

    });

    this.setState({ fields, checkboxes });

    return hasError ? this.props.onError(this.createErrorMessage()) : data;

  }

  createErrorMessage() {
    let fieldsMessages = [];
    let checkboxesMessages = [];
    this.state.fields.forEach(field => {
      if (field.hasError) fieldsMessages.push(field.errorMessage)
    });
    this.state.checkboxes.forEach(checkbox => {
      if (checkbox.hasError) checkboxesMessages.push(checkbox.errorMessage)
    });

    let message = "";

    if (fieldsMessages.length === 1 && checkboxesMessages.length === 0) {
      message = "Для участия в акции необходимо " + fieldsMessages[0];
    }

    if (checkboxesMessages.length === 1 && fieldsMessages.length === 0) {
      message = "Для участия в акции необходимо " + checkboxesMessages[0];
    }

    if (fieldsMessages.length === 1 && checkboxesMessages.length === 1) {
      message = `Для участия в акции необходимо ${fieldsMessages[0]}, ${checkboxesMessages[0]}`;
    }

    if (fieldsMessages.length > 1 && checkboxesMessages.length > 1) {
      message = "Для участия в акции необходимо заполнить все поля";
    }

    if (fieldsMessages.length > 1 && checkboxesMessages.length === 0) {
      message = "Для участия в акции необходимо ввести личные данные";
    }

    if (checkboxesMessages.length > 1 && fieldsMessages.length === 0) {
      message = "Для участия в акции необходимо принять все условия акции";
    }
    return message;
  }

  clearData() {
    const { fields } = this.state;

    fields.forEach(field => {
      field.hasError = false;
      field.value = "";
    });

    this.setState({ fields });
  }

  render() {
    const { fields, checkboxes } = this.state;
    const { socials, onSubmit, name } = this.props;

    return (
      <div className={"pp-section pp-section-form"}>
        <div className={"wrapper-container"}>
          <h2 className={"title"}>Узнайте о скидке</h2>
          <p className={"subtitle"}>на этот продукт в официальном интернет-магазине LG — rushop.lg.com</p>
          {name && <p className={"model"}>{Parser(name)}</p>}
          <div className={"form"}>
            <input id={"valid-bot"} name={"valid-bot"} type={"hidden"} />
            <Fields fields={fields}
                    onChangeInput={this.onChangeInput} />
          </div>
          <div className={"socials-wrapper"}>
            <div className={"or"}>или</div>
            <Socials socials={socials} /></div>
          <Checkboxes checkboxes={checkboxes}
                      onChangeCheckbox={this.onChangeCheckbox} />
          <Button text={"Хочу узнать о скидке"} onClick={onSubmit} />
        </div>
      </div>
    );

  }
}

Form.propTypes = {
  socials: PropTypes.array.isRequired
};

export default Form;
